<template>
  <b-modal
    id="test2"
    v-model="this.$store.state.thankYouModal"
    static
    no-close-on-backdrop
    ok-only
    no-close-on-esc
    :title="'Hello ' + this.$store.state.pii.first_name + ','"
    @close="close"
    @ok="close"
  >
    <p class="text-left">{{this.$store.state.thankYouModalText}}</p>
  </b-modal>
</template>
<script>
export default {
  methods: {
    close (e) {
      e.preventDefault()
      this.$store.commit('showThankYouModal', false)
    }
  }
}
</script>
